"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4580],{

/***/ 3658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66037);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80343);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);






var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {},
        content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.typography.body2), {
            backgroundColor: theme.colors.softGrey,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "center",
            lineHeight: 1.3,
            minHeight: 42,
            padding: theme.spacing(0.5, 2),
            textAlign: "center",
            "& strong": {
                display: "inline-block",
                margin: theme.spacing(0, 0.5),
                padding: theme.spacing(0, 0.5),
                borderRadius: theme.spacing(0.5),
                backgroundColor: theme.colors.warning.main,
                fontWeight: theme.typography.fontWeightBold
            }
        }),
        dark: {
            backgroundColor: "#2f2e41",
            color: theme.palette.common.white,
            "& a": {
                color: theme.colors.logo.shrimp
            }
        },
        light: {},
        big: {
            fontSize: 16
        },
        small: {}
    };
}, {
    classNamePrefix: "Banner"
});
var Banner = function(param) {
    var className = param.className, extClasses = param.classes, children = param.children, inProp = param.in, _variant = param.variant, variant = _variant === void 0 ? "light" : _variant, _size = param.size, size = _size === void 0 ? "small" : _size;
    var classes = useStyles({
        classes: extClasses
    });
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        in: inProp,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.content, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, classes.dark, variant === "dark"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, classes.light, variant === "light"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, classes.big, size === "big"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, classes.small, size === "small"), _obj)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: children
            })
        })
    });
};


/***/ }),

/***/ 8080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_LoadingIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18063);






var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            height: "100%"
        }
    };
}, {
    classNamePrefix: "Loading"
});
var Loading = function(param) {
    var className = param.className, extClasses = param.classes, size = param.size;
    var classes = useStyles({
        classes: extClasses
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            role: "img",
            "aria-label": "Loading",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LoadingIcon__WEBPACK_IMPORTED_MODULE_2__/* .LoadingIcon */ .H, {
                size: size || 64
            })
        })
    });
};


/***/ }),

/***/ 28505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ oidc_GoogleButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/oidc/GoogleButton/img/icon.svg
var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 48 48",
    className: "icon_svg__abcRioButtonSvg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#EA4335",
    d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#4285F4",
    d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#FBBC05",
    d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#34A853",
    d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  })));
}

/* harmony default export */ var icon = (SvgIcon);
;// CONCATENATED MODULE: ./src/components/oidc/GoogleButton/index.tsx







var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            backgroundColor: "#FFF",
            borderRadius: 26,
            boxShadow: "0 2px 4px 0 rgba(0, 0, 0, .1)",
            color: "#262626",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            userSelect: "none",
            transition: theme.transitions.create([
                "box-shadow"
            ], {
                easing: theme.transitions.easing.easeInOut,
                duration: "0.2s"
            }),
            "&:hover": {
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, .1)"
            }
        },
        icon: {
            flexGrow: 0,
            padding: 15,
            backgroundColor: "#fff",
            borderRadius: 26
        },
        iconSmall: {
            flexGrow: 0,
            padding: 8,
            backgroundColor: "#fff"
        },
        svg: {
            display: "block",
            height: 18,
            width: 18
        },
        label: {
            fontSize: "16px",
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: "48px",
            paddingRight: 15
        },
        small: {
            fontSize: "0.9rem",
            fontWeight: 700,
            lineHeight: "30px",
            letterSpacing: "0.21px"
        },
        dark: {
            color: "#fff",
            backgroundColor: "#4285F4",
            border: "1px solid transparent",
            maxWidth: "max-content",
            "&:hover": {
                backgroundColor: "#4285f4"
            },
            "&:active": {
                color: "#fff",
                backgroundColor: "#3367d6"
            },
            "& $label": {
                paddingLeft: 15,
                paddingRight: 24
            }
        },
        disabled: {
            color: (0,colorManipulator/* lighten */.$n)("#262626", 0.25),
            backgroundColor: (0,colorManipulator/* darken */._j)("#FFF", 0.25),
            pointerEvents: "none",
            "&:hover": {
                color: (0,colorManipulator/* lighten */.$n)("#262626", 0.25),
                backgroundColor: (0,colorManipulator/* darken */._j)("#FFF", 0.25),
                boxShadow: "none"
            },
            "&:active": {
                color: (0,colorManipulator/* lighten */.$n)("#262626", 0.25),
                backgroundColor: (0,colorManipulator/* darken */._j)("#FFF", 0.25)
            }
        }
    };
});
var GoogleButton = function(param) {
    var _label = param.label, label = _label === void 0 ? "Log in with Google" : _label, disabled = param.disabled, dark = param.dark, className = param.className, onClick = param.onClick, small = param.small;
    var classes = useStyles();
    var handleClick = function(e) {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (onClick) onClick(e);
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        "aria-label": label,
        onClick: handleClick,
        className: (0,clsx_m/* default */.Z)(classes.root, (_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.dark, dark), (0,_define_property/* default */.Z)(_obj, classes.disabled, disabled), _obj), className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx_m/* default */.Z)(classes.icon, "oidc-google-button-icon", (0,_define_property/* default */.Z)({}, classes.iconSmall, small)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon, {
                    className: classes.svg
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)(classes.label, "oidc-google-button-label", (0,_define_property/* default */.Z)({}, classes.small, small)),
                children: label
            })
        ]
    });
};
/* harmony default export */ var oidc_GoogleButton = (GoogleButton);


/***/ }),

/***/ 83416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useGoogleLogin; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14101);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10469);
/* harmony import */ var _utils_local_storage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91325);
/* harmony import */ var _utils_platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94423);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47310);
/* harmony import */ var _useOurRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52581);







var useGoogleLogin = function() {
    var router = (0,_useOurRouter__WEBPACK_IMPORTED_MODULE_4__/* .useOurRouter */ .ED)();
    var urlParams = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return new URLSearchParams((0,_utils_platform__WEBPACK_IMPORTED_MODULE_2__/* .browser */ .Xh)().isBrowser ? window.location.search : "");
    }, []);
    return (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__/* .useCallbackSafeRef */ .T)(function() {
        var ref;
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt);
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_ATTEMPTS */ .aJ);
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_ACTIVE_QUESTS */ .pZ);
        var storedUser = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .getLocalStorage */ .$o)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_USER */ .kG);
        var ref1 = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .getLocalStorage */ .$o)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_REF */ .ZB);
        var utm = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .getLocalStorage */ .$o)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_UTM */ .$K);
        var slackTeamId = urlParams.get("slackTeamId");
        var slackUserId = urlParams.get("slackUserId");
        var invite = urlParams.get("invite");
        // the check for "://" prevents arbitrary redirection (Open Redirect)
        var oauthRedirect = (ref = router.query.state) === null || ref === void 0 ? void 0 : ref.redirect;
        var redirect = "".concat(!!oauthRedirect && !oauthRedirect.includes("://") ? oauthRedirect : (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .getSessionStorage */ .G)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_REDIRECT */ .I7, "/")).concat(!!invite ? "?invite=1" : "");
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_REDIRECT */ .I7);
        var state = {
            flow: "default",
            redirect: redirect,
            slackTeamId: slackTeamId,
            slackUserId: slackUserId,
            ref: ref1,
            utm: utm
        };
        _reclaim_api__WEBPACK_IMPORTED_MODULE_1__/* .reclaim.users.authRedirect */ .Tz.users.authRedirect("google", storedUser === null || storedUser === void 0 ? void 0 : storedUser.email, state);
    });
};


/***/ }),

/***/ 38757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ LoginLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/components/oidc/GoogleButton/index.tsx + 1 modules
var GoogleButton = __webpack_require__(28505);
// EXTERNAL MODULE: ./src/consts/storageKeys.ts
var storageKeys = __webpack_require__(14101);
// EXTERNAL MODULE: ./src/context/AnalyticsContext.tsx
var AnalyticsContext = __webpack_require__(89495);
// EXTERNAL MODULE: ./src/context/UserContext.tsx + 2 modules
var UserContext = __webpack_require__(15008);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/hooks/useGoogleLogin.ts
var useGoogleLogin = __webpack_require__(83416);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
;// CONCATENATED MODULE: ./src/img/reclaimLogoOnDark.svg
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgReclaimLogoOnDark(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 600 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#reclaimLogoOnDark_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M72.423 44.467c12.123 0 21.952-9.828 21.952-21.952C94.375 10.39 84.546.563 72.423.563 60.299.563 50.47 10.39 50.47 22.515c0 12.123 9.828 21.952 21.952 21.952z",
    fill: "#FAFAEF"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 .474h43.894v43.894H0V.474z",
    fill: "#EE9AB2"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M72.423 53.74l11.454 20.282 11.455 20.273h-45.82l11.456-20.273L72.423 53.74z",
    fill: "#FFC550"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.952 94.612c12.124 0 21.952-9.829 21.952-21.952 0-12.124-9.828-21.952-21.952-21.952C9.828 50.708 0 60.536 0 72.66c0 12.123 9.828 21.952 21.952 21.952z",
    fill: "#5263F3"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M161.149 32.261v14.033a13.73 13.73 0 00-5.708-1.126c-8.818 0-15.267 6.912-15.267 17.775v31.402h-15.019V32.261h15.019v9.214c3.348-6.202 8.69-10.172 15.514-10.172a14.962 14.962 0 015.461.958zm62.626 33.763h-49.374c1.116 9.875 8.561 16.63 17.864 16.63a18.203 18.203 0 0016.135-9.185l12.66 5.086c-4.938 10.3-15.8 17.005-28.42 17.005-20.737 0-33.387-14.28-33.387-32.272 0-17.992 13.657-32.261 33.012-32.261 18.002 0 31.52 12.907 31.777 31.768l-.267 3.229zm-48.021-10.922h31.915c-2.36-7.08-7.82-11.415-15.641-11.415a16.71 16.71 0 00-16.274 11.415zm50.253 8.186c0-18.485 14.813-32.261 33.506-32.261 13.528 0 25.062 7.199 30.158 19.483l-13.41 5.58a17.666 17.666 0 00-16.788-11.169c-10.803 0-18.495 7.693-18.495 18.367 0 10.675 7.692 18.368 18.495 18.368a17.646 17.646 0 0016.788-11.169l13.37 5.55c-5.095 12.284-16.629 19.483-30.158 19.483-18.703.04-33.466-13.736-33.466-32.232zm68.127-62.044h15.02v93.071h-15.02V1.245zm87.453 31.017v62.054h-15.01V86.9c-4.721 5.461-11.672 8.69-20.609 8.69-16.788 0-30.613-14.279-30.613-32.271s13.904-32.261 30.613-32.261c8.937 0 15.888 3.219 20.609 8.68V32.26h15.01zM367.07 63.288a18.369 18.369 0 00-21.95-18.014 18.37 18.37 0 00-14.431 14.431 18.366 18.366 0 0018.014 21.95 18.255 18.255 0 0013.023-5.344 18.235 18.235 0 005.344-13.023zm23.285-54.351a8.93 8.93 0 1117.864 0 8.932 8.932 0 01-17.864 0zm1.363 23.324h15.01v62.054h-15.01V32.261zm114.115 22.713v39.341h-15.02V56.09a10.806 10.806 0 00-6.753-10.387 10.802 10.802 0 00-4.297-.782c-6.577 0-10.912 5.214-10.912 11.672v37.722h-15.02V56.09a10.788 10.788 0 00-3.117-7.967 10.798 10.798 0 00-7.933-3.202c-6.695 0-10.862 5.214-10.862 11.672v37.722H416.85V32.261h14.98v6.083a19.307 19.307 0 0114.892-7.317c6.912 0 13.4 3.723 17.616 9.677a21.824 21.824 0 0118.368-9.677c13.193 0 23.127 10.546 23.127 23.947zm70.171-22.713v62.054h-10.171V85.38c-5.343 6.33-13.41 10.18-23.335 10.18-16.629 0-31.027-14.397-31.027-32.27 0-17.874 14.398-32.262 31.027-32.262 9.925 0 17.992 3.841 23.335 10.171v-8.887l10.171-.05zm-10.171 31.027a22.093 22.093 0 00-26.4-21.665 22.095 22.095 0 00-17.356 17.356 22.084 22.084 0 009.393 22.677 22.092 22.092 0 0012.273 3.723 21.98 21.98 0 0022.07-22.09h.02zm20.273-56.376a6.947 6.947 0 1113.893 0 6.947 6.947 0 01-13.893 0zm1.856 25.31h10.181v62.093h-10.181V32.222z",
    fill: "#FAFAEF"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "reclaimLogoOnDark_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h600v95.56H0z"
  })))));
}

/* harmony default export */ var reclaimLogoOnDark = (SvgReclaimLogoOnDark);
// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 7 modules
var reclaim_api = __webpack_require__(10469);
// EXTERNAL MODULE: ./src/utils/local-storage.ts
var local_storage = __webpack_require__(91325);
// EXTERNAL MODULE: ./src/utils/platform.ts
var platform = __webpack_require__(94423);
// EXTERNAL MODULE: ./src/layouts/LandingLayout.tsx + 3 modules
var LandingLayout = __webpack_require__(29203);
;// CONCATENATED MODULE: ./src/layouts/pages/LoginLayout.tsx























var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        body: {
            margin: theme.spacing(4, 0)
        },
        o365Callout: {
            backgroundColor: "rgba(47, 46, 65, .5)",
            borderRadius: 4,
            margin: theme.spacing(5, "auto", 0),
            maxWidth: 400,
            padding: theme.spacing(2),
            "& a": {
                color: theme.colors.logo.shrimp,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        gridContainer: {
            backgroundColor: theme.colors.logo.darkness,
            color: theme.colors.white,
            height: "100%",
            padding: theme.spacing(2),
            width: "100vw"
        },
        wrapper: {
            textAlign: "center",
            maxWidth: 600,
            width: "100%"
        },
        logoBtn: {
            display: "block"
        },
        logoSvg: {
            height: "auto",
            marginBottom: theme.spacing(2),
            maxWidth: 200,
            width: "100%"
        },
        googleBtn: {
            margin: theme.spacing(0, "auto", 3),
            maxWidth: 360,
            transform: "scale(1)",
            transition: "transform .2s ease",
            width: "100%",
            "&:hover": {
                transform: "scale(1.02)"
            }
        },
        signupText: {
            margin: theme.spacing(2, 0),
            "& a": {
                color: theme.colors.logo.shrimp,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        ssoFieldsContainer: (0,_define_property/* default */.Z)({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: theme.spacing()
        }, theme.breakpoints.up("sm"), {
            flexDirection: "row"
        }),
        ssoButton: (0,_define_property/* default */.Z)({
            padding: theme.spacing(2, 2.25),
            width: "200"
        }, theme.breakpoints.up("sm"), {
            width: "auto"
        }),
        ssoTextFieldInput: (_obj = {
            borderRadius: 9999,
            backgroundColor: "white",
            width: 300
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            width: 280
        }), (0,_define_property/* default */.Z)(_obj, "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline", {
            borderColor: theme.palette.primary.light
        }), _obj)
    };
}, {
    index: 2,
    name: "LoginTemplate"
});
var LoginLayout = function(param) {
    var title = param.title, displayLoginButton = param.displayLoginButton, officeNotice = param.officeNotice, children = param.children;
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    var classes = useStyles(theme);
    /********************/ /*   custom hooks   */ /********************/ var medium = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), ref2 = ref1[0], user = ref2.user, isAuthenticated = ref2.isAuthenticated, status = ref2.status;
    var handleGoogleLogin = (0,useGoogleLogin/* useGoogleLogin */.N)();
    var ref3 = (0,AnalyticsContext/* useAnalyticsContext */.Os)(), sentry = ref3.state.sentry;
    /********************/ /*     useState     */ /********************/ var ref4 = (0,react.useState)(), error = ref4[0], setError = ref4[1];
    var ref5 = (0,react.useState)(), ssoEmail = ref5[0], setSsoEmail = ref5[1];
    var ref6 = (0,react.useState)(false), isSso = ref6[0], setIsSso = ref6[1];
    var ssoInputRef = (0,react.useRef)(null);
    /********************/ /* useMemo & consts */ /********************/ var urlParams = (0,react.useMemo)(function() {
        return new URLSearchParams((0,platform/* browser */.Xh)().isBrowser ? window.location.search : "");
    }, []);
    /********************/ /*    useCallback   */ /********************/ var handleClick = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(provider) {
        if (provider === "google") {
            handleGoogleLogin();
        }
    });
    var handleSSOInputChange = function(e) {
        setSsoEmail(e.target.value);
    };
    var handleSSOLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var urlPath, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!ssoEmail) {
                            setError("No SSO E-mail provided.");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            reclaim_api/* reclaim.users.ssoLogin */.Tz.users.ssoLogin(ssoEmail)
                        ];
                    case 2:
                        urlPath = _state.sent();
                        if (urlPath) {
                            reclaim_api/* reclaim.users.authRedirect */.Tz.users.authRedirect(urlPath.replace("/oauth/login/", ""));
                            return [
                                2
                            ];
                        }
                        setError("No associated SSO e-mail found.");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setError("Error while feching SSO URL.");
                        sentry === null || sentry === void 0 ? void 0 : sentry.captureException("Error while fetching URL", error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSSOLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSSOKeyPress = function(e) {
        if (e.key === "Enter") {
            void handleSSOLogin();
        }
    };
    var handleRemoveError = function() {
        void router.replace("/login", undefined, {
            shallow: true
        });
        setError(undefined);
    };
    /********************/ /*    useEffects    */ /********************/ (0,react.useEffect)(function() {
        var ref;
        if (!((ref = router.query) === null || ref === void 0 ? void 0 : ref.reason)) return;
        var reason = router.query.reason;
        setError("USER_DISABLED" === reason ? "Calendar for this email address is linked to another account. Please sign in using your other Google login." : "User not authorized.");
    }, [
        (ref = router.query) === null || ref === void 0 ? void 0 : ref.reason
    ]);
    // focus when isSso changes to true
    (0,react.useEffect)(function() {
        var ref;
        isSso && ((ref = ssoInputRef.current) === null || ref === void 0 ? void 0 : ref.focus());
    }, [
        isSso
    ]);
    // Redirect if user is already authenticated
    (0,react.useEffect)(function() {
        var ref;
        if (!router.isReady || !isAuthenticated) return;
        (0,local_storage/* removeLocalStorage */.dZ)(storageKeys/* LOCAL_STORAGE_AUTH_REAUTH */.Vt);
        (0,local_storage/* removeLocalStorage */.dZ)(storageKeys/* LOCAL_STORAGE_AUTH_ATTEMPTS */.aJ);
        var slackTeamId = urlParams.get("slackTeamId");
        var slackUserId = urlParams.get("slackUserId");
        // the check for "://" prevents arbitrary redirection (Open Redirect)
        var oauthRedirect = (ref = router.query.state) === null || ref === void 0 ? void 0 : ref.redirect;
        var redirect = !!oauthRedirect && !oauthRedirect.includes("://") ? oauthRedirect : (0,local_storage/* getSessionStorage */.G)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7);
        var hasSharedHabit = !!(0,local_storage/* getLocalStorage */.$o)("habits.sharedPreset");
        if (redirect) {
            (0,local_storage/* removeSessionStorage */.VV)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7);
        }
        // connect slack user
        if (slackUserId && slackTeamId) {
            reclaim_api/* reclaim.slack.link */.Tz.slack.link(slackUserId, slackTeamId).catch(function(reason) {
                if (404 === reason.status) {
                    sentry === null || sentry === void 0 ? void 0 : sentry.captureException("Slack user not found, redirecting" + reason);
                    reclaim_api/* reclaim.slack.authRedirect */.Tz.slack.authRedirect(slackTeamId);
                    return;
                } else {
                    sentry === null || sentry === void 0 ? void 0 : sentry.captureException("Failed to link slack user " + reason);
                }
            });
        }
        var pathname = "/onboarding/welcome";
        if (user === null || user === void 0 ? void 0 : user.onboarded) {
            if (hasSharedHabit) pathname = "/habits";
            else if (redirect) pathname = redirect;
            else if (medium) pathname = "/stats";
            else pathname = "planner";
        }
        void router.push({
            pathname: pathname,
            query: router.query
        });
    }, [
        isAuthenticated,
        medium,
        router,
        sentry,
        urlParams,
        user === null || user === void 0 ? void 0 : user.onboarded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingLayout/* default */.Z, {
        title: title,
        loading: [
            "init",
            "loading"
        ].includes(status) || !!isAuthenticated,
        hideNav: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            className: classes.gridContainer,
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        className: classes.logoBtn,
                        component: Link/* Link */.r,
                        href: !!user ? "/" : "//reclaim.ai",
                        size: "medium",
                        "aria-label": "reclaim.ai",
                        disableTouchRipple: true,
                        disableRipple: true,
                        disableFocusRipple: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reclaimLogoOnDark, {
                            className: classes.logoSvg
                        })
                    }),
                    children,
                    isSso && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.ssoFieldsContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                InputProps: {
                                    className: classes.ssoTextFieldInput
                                },
                                ref: ssoInputRef,
                                type: "text",
                                value: ssoEmail,
                                variant: "outlined",
                                placeholder: "Enter your email",
                                onChange: handleSSOInputChange,
                                onKeyPress: handleSSOKeyPress
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                className: classes.ssoButton,
                                onClick: handleSSOLogin,
                                children: "Log in with SSO"
                            })
                        ]
                    }),
                    !!displayLoginButton && !isSso && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleButton/* default */.Z, {
                        label: "Continue with Google",
                        onClick: function() {
                            handleRemoveError();
                            handleClick("google");
                        },
                        className: classes.googleBtn
                    }),
                    !!error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "body1",
                        color: "error",
                        className: classes.body,
                        children: [
                            error,
                            "\xa0 If you believe this to be an error, please contact support."
                        ]
                    }),
                    !!officeNotice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "body2",
                        className: classes.o365Callout,
                        children: [
                            "At this time, Reclaim only works on Google Calendar. Interested in Office 365?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                href: "mailto:hello@reclaim.ai?subject=Re:%20Office%20365%20Support%20for%20Reclaim&body=Hi%20Reclaim%20Team!%0D%0A%0D%0AI'm%20an%20Office%20365%20user%20and%20would%20love%20to%20stay%20updated%20when%20Reclaim%20works%20for%20O365%20calendars.%0D%0A%0D%0AThanks!",
                                children: "Let\xa0us\xa0know"
                            })
                        ]
                    }),
                    !!displayLoginButton && !isSso && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: router.pathname.startsWith("/login") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: classes.signupText,
                            variant: "body2",
                            children: [
                                "Don't have an account? ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/signup",
                                    children: "Sign up"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: classes.signupText,
                            variant: "body2",
                            children: [
                                "Have an account? ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/login",
                                    children: "Log in"
                                })
                            ]
                        })
                    }),
                    !isSso ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.signupText,
                        variant: "body2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            onClick: function() {
                                handleRemoveError();
                                setIsSso(true);
                            },
                            children: "Log in with SSO"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.signupText,
                        variant: "body2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            onClick: function() {
                                handleRemoveError();
                                setIsSso(false);
                            },
                            children: "Go back"
                        })
                    })
                ]
            })
        })
    });
};


/***/ })

}]);